/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionBanContainer_user = {
    readonly id: string;
    readonly status: {
        readonly ban: {
            readonly active: boolean;
        };
    };
    readonly " $refType": "ModerationActionBanContainer_user";
};
export type ModerationActionBanContainer_user$data = ModerationActionBanContainer_user;
export type ModerationActionBanContainer_user$key = {
    readonly " $data"?: ModerationActionBanContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionBanContainer_user">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionBanContainer_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "BanStatus",
                    "kind": "LinkedField",
                    "name": "ban",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'f17bb57c7baed3abe9e2076107029be2';
export default node;
